import { useQuery } from '@tanstack/react-query';

export interface Category {
    category_id: string;
    category_name: string;
    parent_id: number;
}

interface UseCategoriesParams {
    baseUrl: string;
    username: string;
    password: string;
    action: 'get_live_categories' | 'get_vod_categories' | 'get_series_categories';
}

export const useCategories = ({ baseUrl, username, password, action }: UseCategoriesParams) => {
    return useQuery<Category[], Error>({
        queryKey: ['categories', baseUrl, username, action],
        queryFn: async () => {
            const url = `${baseUrl}/player_api.php?username=${username}&password=${password}&action=${action}`;

            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`Failed to fetch categories: ${response.statusText}`);
            }

            const data: Category[] = await response.json();
            return data;
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
    });
};